import "./Switch.css";
import React, { useEffect, useState, useCallback } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../../index";
import { useNavigate } from "react-router-dom";

const processUserData = (usersData) => {
  const authorizedUsers = [];
  for (const userID in usersData) {if (usersData.hasOwnProperty(userID)) {
      const user = usersData[userID];
      authorizedUsers.push(user);
    }
  }
  return authorizedUsers;
};

const UserListItem = ({ user, onClick }) => {
  return (
    <div className="items-table__list items-table__disp items-table__hover" key={user.userID} onClick={onClick}>
      <div className="items-table__disp-holder list-user">
        <h2>{user.role}</h2>
        <p>{user.email}</p>
      </div>
      <div className="items-table__disp-holder">
        <p>{user.displayName || "Не указано"}</p>
      </div>
      <div className="items-table__disp-holder">
        <p>{user.phoneNumber || "Не указан"}</p>
      </div>
    </div>
  );
};

export function Switch() {
  const [authorizedUsers, setAuthorizedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [roleQuery, setRoleQuery] = useState(""); 
  const navigate = useNavigate();

  useEffect(() => {
    const usersRef = ref(db, "users");
    onValue(usersRef, (snapshot) => {
      const usersData = snapshot.val();
      setAuthorizedUsers(processUserData(usersData));
    });
  }, []);

  const handleUserClick = useCallback((switchID) => {
    navigate(`/switch/${switchID}`);
  }, [navigate]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleRoleChange = (event) => {
    setRoleQuery(event.target.value);
  };

  const filteredUsers = authorizedUsers.filter((user) => {
    const emailMatch = user.email.toLowerCase().includes(searchQuery.toLowerCase());
    const nameMatch = user.displayName.toLowerCase().includes(searchQuery.toLowerCase());
    const phoneMatch = user.phoneNumber.toLowerCase().includes(searchQuery.toLowerCase());
    const roleFilter = roleQuery === "" || user.role === roleQuery;
    return (emailMatch || nameMatch || phoneMatch) && roleFilter;
  });

  return (
    <div className="table__dispatcher">
      <h1>Аккаунты</h1>
      <div className="items-table__search-subtitle">
        <input className="field-input field-search" type="search" value={searchQuery} onChange={handleSearch} placeholder="Поиск по email, имени или телефону" />
      </div>
      <div className="items-table__search-title">
        <select className="field-input" value={roleQuery} onChange={handleRoleChange}>
          <option value="">Все роли</option>
          <option value="Директор">Директор</option>
          <option value="Инженер">Инженер</option>
          <option value="Диспетчер">Диспетчер</option>
        </select>
      </div>
      <div className="items-table__list media-switch">
        <span>Email</span>
        <span>Имя</span>
        <span>Телефон</span>
      </div>
      {filteredUsers.map((user) => (
        <UserListItem key={user.userID} user={user} onClick={() => handleUserClick(user.userID)} />
      ))}
    </div>
  );
}